module.exports = __webpack_public_path__ + "static/img/dataReport.030a2e2f.png";